// Copyright (c) AdCritter. All rights reserved.

import moment from 'moment'
import { FC } from 'react'

import { EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'

import { AIPlanPreview } from 'api/entities/AIPlanPreview'
import { MasterCampaignPlanCampaignBuilder } from 'api/entities/MasterCampaignStub'

import Budget from 'pages/MasterCampaignPlanPage/new/components/Budget'
import CampaignTimeline from 'pages/MasterCampaignPlanPage/new/components/ExecutiveSummary/CampaignTimeline'
import RenderCustomSections from 'pages/MasterCampaignPlanPage/new/components/RenderCustomSections'
import TabPageHeader from 'pages/MasterCampaignPlanPage/new/components/TabPageHeader'
import { AIPlanCampaignCard } from './AIPlanCampaignCard'

interface AIPlanMediaPlanProps {
  aiPlan: AIPlanPreview
}

const AIPlanMediaPlan: FC<AIPlanMediaPlanProps> = ({ aiPlan }) => {
  const campaigns = (aiPlan.aiPlanStub?.campaignBuilders ?? []) as unknown as MasterCampaignPlanCampaignBuilder[]
  const planStartDate = moment(aiPlan.aiUsedStartDate)
  const planDurationMonths = aiPlan.aiUsedDurationInMonths
  const section = aiPlan.mediaPlanSection

  const pageTitle = section?.pageTitle || 'Media Plan'
  const campaignDetailsTitle = section?.campaignDetailsTitle || 'Campaign Details'

  const aiPlanCampaigns = aiPlan.aiPlanStub?.campaignBuilders ?? []
  const listCampaigns = [...aiPlanCampaigns]
    .sort((a, b) => moment(a.startDate).valueOf() - moment(b.startDate).valueOf())
    .map(builder => (
      <div key={builder.id} style={{ marginBottom: '1rem' }}>
        <AIPlanCampaignCard builder={builder} />
      </div>
    ))

  return (
    <>
      <TabPageHeader title={pageTitle} />

      {section?.budget?.hideAll !== true && (
        <>
          <Budget campaigns={campaigns} useMediaPlanWording={true} section={section?.budget as any} />
          <EuiSpacer size='xl' />
        </>
      )}

      <RenderCustomSections sections={section?.aboveCampaignTimeline as any} />

      <CampaignTimeline campaigns={campaigns} planStartDate={planStartDate} planDurationMonths={planDurationMonths} isHoverable isClickable />

      <EuiSpacer size='xxl' />

      <RenderCustomSections sections={section?.aboveCampaignDetails as any} />

      <EuiFlexGroup>
        <EuiFlexItem>
          <EuiFlexGroup alignItems='center'>
            <EuiFlexItem grow={false}>
              <EuiTitle size='s'>
                <h4>{campaignDetailsTitle}</h4>
              </EuiTitle>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
      </EuiFlexGroup>

      <EuiSpacer size='m' />

      <div style={{ width: '100%' }}>{listCampaigns}</div>

      {campaigns.length === 0 && (
        <EuiText>
          <p>No campaigns have been configured for this plan yet.</p>
        </EuiText>
      )}
    </>
  )
}

export default AIPlanMediaPlan
